/* unplugin-vue-components disabled */import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=b81809a6&lang=scss"

const __exports__ = script;

export default __exports__